import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import _ from "lodash";
import styled from "styled-components";

import {
  ChildSectionTitle,
  SideLabelTextAreaWithRefInput,
  SideLabelTextWithRefInput,
  SideLabelPercentWithRefInput,
  SideLabelIntegerWithRefInput,
  SideLabelMoneyWithRefInput,
  SideLabelDateInput,
  SideLabelAutoCompleteWithRefInput
} from "../FormSectionComponents";

const StyledGrid = styled(Grid)`
  &&& {
    width:1200px;
  }
`;
class FinancialReportingChildSection extends React.Component {
  render() {
    const { isEditing, frequencies } = this.props;
    const formik = this.props.formik;

    return (
      <div id="covenants_section_financial_reporting">
        <ChildSectionTitle>Financial Reporting</ChildSectionTitle>
        <StyledGrid container alignItems="center" direction="column">
          <SideLabelTextAreaWithRefInput label="Borrower Docs Monthly" hasBorder placeholder="Borrower Docs" fieldName="covenants.borrowerDocsMonthly" isDisabled={!isEditing} />
          <SideLabelDateInput isShort hasBorder isIndented formik={formik} label="Reporting Start" fieldName="covenants.borrowerDocsMonthlyReportingStart" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="Borrower Docs Quarterly" hasBorder placeholder="Borrower Docs Quarterly" fieldName="covenants.borrowerDocsQuarterly" isDisabled={!isEditing} />
          <SideLabelDateInput isShort hasBorder isIndented formik={formik} label="Reporting Start" fieldName="covenants.borrowerDocsQuarterlyReportingStart" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="Borrower Docs SemiAnnually" hasBorder placeholder="Borrower Docs" fieldName="covenants.borrowerDocsSemiAnnually" isDisabled={!isEditing} />
          <SideLabelDateInput isShort hasBorder isIndented formik={formik} label="Reporting Start" fieldName="covenants.borrowerDocsSemiAnnuallyReportingStart" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="Borrower Docs Annually" hasBorder placeholder="Borrower Docs" fieldName="covenants.borrowerDocsAnnually" isDisabled={!isEditing} />
          <SideLabelDateInput isShort hasBorder isIndented formik={formik} label="Reporting Start" fieldName="covenants.borrowerDocsAnnuallyReportingStart" isDisabled={!isEditing} />

          <SideLabelTextAreaWithRefInput label="Guarantor Docs Monthly" hasBorder placeholder="Guarantor Docs" fieldName="covenants.guarantorDocsMonthly" isDisabled={!isEditing} />
          <SideLabelDateInput isShort hasBorder isIndented formik={formik} label="Reporting Start" fieldName="covenants.guarantorDocsMonthlyReportingStart" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="Guarantor Docs Quarterly" hasBorder placeholder="Guarantor Docs" fieldName="covenants.guarantorDocsQuarterly" isDisabled={!isEditing} />
          <SideLabelDateInput isShort hasBorder isIndented formik={formik} label="Reporting Start" fieldName="covenants.guarantorDocsQuarterlyReportingStart" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="Guarantor Docs SemiAnnually" hasBorder placeholder="Guarantor Docs" fieldName="covenants.guarantorDocsSemiAnnually" isDisabled={!isEditing} />
          <SideLabelDateInput isShort hasBorder isIndented formik={formik} label="Reporting Start" fieldName="covenants.guarantorDocsSemiAnnuallyReportingStart" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="Guarantor Docs Annually" hasBorder placeholder="Guarantor Docs" fieldName="covenants.guarantorDocsAnnually" isDisabled={!isEditing} />
          <SideLabelDateInput isShort hasBorder isIndented formik={formik} label="Reporting Start" fieldName="covenants.guarantorDocsAnnuallyReportingStart" isDisabled={!isEditing} />

          <SideLabelAutoCompleteWithRefInput
            label="Reporting Frequency"
            id="dropdownForReportingFrequency"
            options={frequencies}
            refFieldName="covenants.reportingFrequencyIdRef"
            selectName="name"
            selectValue="value"
            fieldName="covenants.reportingFrequencyId"
            hasBorder
            isDisabled={!isEditing}
          />
          <SideLabelTextAreaWithRefInput
            label="Misc."
            placeholder="Misc."
            fieldName="covenants.financialReportingMisc"
            isDisabled={!isEditing}
          />
        </StyledGrid>
      </div>
    );
  }
}
export default FinancialReportingChildSection;
